"use client"

import { signout } from "@lib/data/customer"
import { useParams } from "next/navigation"

export default function SignOutButton() {
  const { countryCode } = useParams() as { countryCode: string }

  return (
    <button
      onClick={async () => {
        try {
          await signout(countryCode)
        } catch (err: any) {
          if (err?.digest?.startsWith("NEXT_REDIRECT")) throw err
        }
      }}
      className="w-full px-4 py-2.5 text-left text-[11px] font-medium uppercase tracking-[0.14em] text-[#666] transition-colors hover:text-[#1A1A1A]"
    >
      Sign Out
    </button>
  )
}
